<template>
    <div>
        <div class="header">
            <div class="wrap">
                <router-link to="/index">
                    <img class="logo" src="./../assets/img/logo.png" alt="logo">
                </router-link>
                <ul class="nav">
                    <li v-for="(item,index) in nav" :key="index" :class="{'active':item.path==$route.path}">
                        <router-link :to="{path: item.path}"><span>{{item.name}}</span></router-link>
                    </li>
                    <el-dropdown @command="chooseLanguage" class="language">
                        <span class="el-dropdown-link">
                            {{language}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item v-for="(item,index) in languageList" :key="index" :command="item.id">{{item.name}}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            nav: [
                {
                    name: '首页',
                    path: '/index'
                },
                {
                    name: '医疗',
                    path: '/medical'
                },
                {
                    name: '健康',
                    path: '/health'
                },
                {
                    name: '旅行',
                    path: '/travel'
                },
                {
                    name: '马术',
                    path: '/horsemanship'
                },
                {
                    name: '关于我们',
                    path: '/about'
                },
                {
                    name: '联系我们',
                    path: '/contact'
                },
                // {
                //     name: 'English',
                //     path: '/'
                // },
                // {
                //     name: 'Deutsch',
                //     path: '/'
                // },
            ],
            languageList: [
                {
                    id: 1,
                    name: '中文',
                    path: '',
                },
                {
                    id: 2,
                    name: 'English',
                    path: ''
                },
                {
                    id: 3,
                    name: 'Deutsch',
                    path: ''
                },
            ],
        }
    },

    methods: {
        chooseLanguage(command){
            console.log(command);
            this.$store.commit('changeSelectLanguage',command)
        }
    },

    computed: {
        language(){
            let lang = '';
            this.languageList.forEach((item,index)=>{
                console.log(item);
                if(item.id == this.$store.state.selectLanguage){
                    lang = item.name;
                }
            })
            return lang;
        }
    },

    components: {},
}

</script>

<style scoped lang="less">
@import "./../assets/css/header.less";
</style>


// WEBPACK FOOTER //
// src/components/header.vue